module.exports = {

    socket: {
        host: 'hawk.so',
        path: 'catcher/client',
        port: 8070,
        secure: true
    }

};



// WEBPACK FOOTER //
// ./src/config.js